import React from 'react';
import Layout from './Containers/Layout';

const App = props => (
    <Layout />
)

export default App;